import React from 'react'
import { AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons';
import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import { SaleLotCategory } from '@sales/data/lots/categories/LotCategoryData';
import { useLotCategoriesDeleteCategoryAction } from '@sales/data/lots/categories/LotCategoryDataActions';
import LotCategoryDialog from '../../../lotCategories/dialogs/LotCategoryDialog';

const LotCategoryActionMenu = (props: { category: SaleLotCategory }) => {
    const lotRemovalAction = useLotCategoriesDeleteCategoryAction();

    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Lot">
                <LotCategoryDialog.Button lotCategoryId={props.category.id} />
                <AgTechButton
                    text="Delete Category"
                    icon="fas fa-times"
                    action={async e => {
                        await e.actions.executeDataActionInModal(lotRemovalAction, {
                            originalEntity: props,
                            submittedEntity: props
                        });
                    }}
                />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
}

export default LotCategoryActionMenu